import React from 'react';
import { PropTypes } from 'prop-types';

import FormViewButton from 'components/Common/Buttons/FormViewButton';
import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';

/* eslint-disable max-len */
// eslint-disable-next-line import/prefer-default-export
export const FormActionsCellRenderer = ({
  value: formId,
  data: form,
  node,
  context: { permissions, getAuditTrailFileCallback, getOriginalPdfFileCallback,
    getAllocationStatementFileCallback }
}) => (
  <div>
    <div className="form-action-btn-group">
      { (window.navigator && typeof (window.navigator.msSaveOrOpenBlob) !== 'undefined')
        ? AccessControl.hasPermission(permissions, [ActivityPerms.scannedView])
          && <button
            type="button"
            title="View original PDF"
            className="btn btn-sm btn-action"
            onClick={ () => getOriginalPdfFileCallback(form.formId) }
            disabled={ form.hasPdfFile !== true }
          >
            <span className="icon icon-photo" />
          </button>
        : AccessControl.hasPermission(permissions, [ActivityPerms.scannedView])
          && <a
            href={ `/forms/${ form.formType.toLowerCase() }/${ formId }/pdf` }
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-sm btn-action"
            title="View original PDF"
            disabled={ form.hasPdfFile !== true }
          >
            <span className="icon icon-photo" />
          </a> }
      { form.hasAllocationStmnts === true && AccessControl.hasPermission(permissions, [ActivityPerms.scannedDownload])
        && <button
          type="button"
          className="btn btn-sm btn-action"
          onClick={ () => getAllocationStatementFileCallback(form.formId) }
          disabled={ form.hasAllocationStmnts !== true }
          title="View witholding statement"
        >
          <span className="icon icon-share" />
        </button> }
      { ((form.isOnlineForm && AccessControl.hasPermission(permissions, [ActivityPerms.electronicView, ActivityPerms.electronicValidate]))
          || (!form.isOnlineForm && AccessControl.hasPermission(permissions, [ActivityPerms.scannedView, ActivityPerms.scannedEdit, ActivityPerms.scannedValidate])))
          && <FormViewButton
            permissions={ permissions }
            formId={ form.formId }
            form={ form }
            content={ <span className="icon icon-apps" /> }
            className="btn btn-sm btn-action"
            title="View digitised version"
          /> }
    </div>
    { (form.beneficiaryForms != null && [...form.beneficiaryForms].length > 0)
      && AccessControl.hasPermission(permissions, [ActivityPerms.scannedView, ActivityPerms.scannedEdit, ActivityPerms.scannedValidate,
        ActivityPerms.electronicView, ActivityPerms.electronicValidate])
        && <div className="form-action-ben-owners">
          <div className="ben-owner-title">Attached Beneficiary Forms</div>
          { [...form.beneficiaryForms].map((item, key) => item != null && (
            (window.navigator && typeof (window.navigator.msSaveOrOpenBlob) !== 'undefined')
              ? <div className="form-action-btn-group" key={ item.controlId } style={ { padding: '5px 0 0' } }>
                { AccessControl.hasPermission(permissions, [ActivityPerms.scannedView])
                && <button
                  type="button"
                  title="View original PDF"
                  className="btn btn-sm btn-action"
                  onClick={ () => getOriginalPdfFileCallback(item.formId) }
                  disabled={ form.hasPdfFile !== true }
                >
                  <span className="icon icon-photo" />
                </button> }
                { AccessControl.hasPermission(permissions, [ActivityPerms.scannedView, ActivityPerms.scannedEdit,
                  ActivityPerms.scannedValidate, ActivityPerms.electronicView, ActivityPerms.electronicValidate])
                  && <FormViewButton
                    permissions={ permissions }
                    formId={ item.formId }
                    form={ item }
                    content={ <span className="icon icon-apps" /> }
                    className="btn btn-sm btn-action"
                    title="View digitised version"
                  /> }
              </div> : <div className="form-action-btn-group" key={ item.controlId } style={ { padding: '5px 0 0' } }>
                { AccessControl.hasPermission(permissions, [ActivityPerms.scannedView]) && <a
                  href={ `/forms/${ item.formType }/${ item.formId }/pdf` }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm btn-action"
                  title="View original PDF"
                  disabled={ form.hasPdfFile !== true }
                >
                  <span className="icon icon-photo" />
                </a> }
                { AccessControl.hasPermission(permissions, [ActivityPerms.scannedView, ActivityPerms.scannedEdit,
                  ActivityPerms.scannedValidate, ActivityPerms.electronicView, ActivityPerms.electronicValidate])
                  && <FormViewButton
                    permissions={ permissions }
                    formId={ item.formId }
                    form={ item }
                    content={ <span className="icon icon-apps" /> }
                    className="btn btn-sm btn-action"
                    title={ `${ item.originalFilename }` }
                  /> }
              </div>
          )) }
        </div> }
    { form.hasAllocationStmnts
      && AccessControl.hasPermission(permissions, [ActivityPerms.scannedView, ActivityPerms.scannedViewTree], true)
      && <div className="form-action-btn-group tree-button">
        <a
          href={ `/w8imystructure/${ formId }/${ form.accountId }` }
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-sm btn-action"
          title="W-8IMY Structure"
        >
          <span className="icon icon-location" />
        </a>
      </div> }
  </div>
);

FormActionsCellRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  data: PropTypes.shape({
    formId: PropTypes.number,
    formType: PropTypes.string,
    isOnlineForm: PropTypes.bool,
    hasPdfFile: PropTypes.bool,
    hasAllocationStmnts: PropTypes.bool,
    beneficiaryForms: PropTypes.arrayOf(PropTypes.shape()),
    accountId: PropTypes.number
  }).isRequired,
  node: PropTypes.shape({}).isRequired,
  context: PropTypes.shape({
    permissions: PropTypes.arrayOf(PropTypes.string),
    getAuditTrailFileCallback: PropTypes.func,
    getOriginalPdfFileCallback: PropTypes.func,
    getAllocationStatementFileCallback: PropTypes.func
  })
};

FormActionsCellRenderer.defaultProps = {
  context: {}
};
